import CountDown from '~/components/CountDown';

import { MembershipEventIcon } from '~/assets/icons';

interface Props {
  initialTime: number;
}

export function PmwkPromotionCountdown({ initialTime }: Props) {
  return (
    <div className="flex justify-center rounded-[8px] py-4 bg-plusmembership-event-badge">
      <p className="flex items-center justify-center gap-4 text-gray-000 typo-caption100-semibold">
        <MembershipEventIcon />
        중복할인 <CountDown initialTime={initialTime} isDot /> 남음
      </p>
    </div>
  );
}
